@if (backgroundImageUrl) {
  <div class="zwi-embed-graphic">
    <div class="zwi-embed-cover-art zwi-embed-art-cover" [style.background-image]="backgroundImageUrl"></div>
  </div>
}

